import { render, staticRenderFns } from "./FurtherQuestionsType.vue?vue&type=template&id=33e4171b&"
import script from "./FurtherQuestionsType.vue?vue&type=script&lang=ts&"
export * from "./FurtherQuestionsType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports